import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Mail, Loader2, MailCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/components/AuthShell";
import { formatApiError } from "@/context/AuthContext";
import { API } from "@/lib/api";
import { T } from "@/lib/i18n";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ loading: false, sent: false, error: "" });

  const onSubmit = async (e) => {
    e.preventDefault();
    setState({ loading: true, sent: false, error: "" });
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setState({ loading: false, sent: true, error: "" });
    } catch (err) {
      setState({ loading: false, sent: false, error: formatApiError(err) });
    }
  };

  return (
    <AuthShell title={T("Password dimenticata", "Forgot password")} subtitle={T("Inserisci l'email del tuo account: ti mandiamo un link per sceglierne una nuova.", "Enter your account email: we'll send you a link to choose a new one.")}>
      {state.sent ? (
        <div data-testid="forgot-sent" className="border border-[#27272a] bg-[#18181b] p-5 space-y-2 text-sm">
          <div className="flex items-center gap-2 font-medium"><MailCheck className="w-5 h-5 text-[#10b981]" />{T("Controlla la tua email", "Check your email")}</div>
          <p className="text-[#a1a1aa]">{T("Se l'email è registrata, riceverai a breve un link valido 1 ora. Guarda anche nello spam.", "If the email is registered you'll soon get a link valid for 1 hour. Check your spam folder too.")}</p>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#71717a]" />
            <Input data-testid="forgot-email-input" type="email" autoComplete="email" placeholder={T("email@azienda.com")} value={email} onChange={(e) => setEmail(e.target.value)} required
              className="pl-10 h-12 bg-[#18181b] border-[#27272a] text-white placeholder:text-[#52525b] rounded-sm font-mono text-sm" />
          </div>
          {state.error && <p data-testid="forgot-error" className="text-sm text-[#f87171]">{state.error}</p>}
          <Button type="submit" data-testid="forgot-submit-btn" disabled={state.loading} className="w-full h-12 aurora-gradient hover:opacity-90 text-white rounded-sm font-medium">
            {state.loading ? <Loader2 className="w-4 h-4 animate-spin" /> : T("Inviami il link", "Send me the link")}
          </Button>
        </form>
      )}
      <p className="mt-8 text-sm text-[#71717a] text-center">
        <Link data-testid="forgot-back-login" to="/login" className="aurora-text font-medium">{T("Torna al login", "Back to login")}</Link>
      </p>
    </AuthShell>
  );
}
